import { useTranslation } from 'react-i18next';
import styled, { keyframes } from 'styled-components';

const toastAnimation = keyframes`
  0% {top: 0; opacity: 0;}
  20%, 80% {top: 24px; opacity: 1;}
  100% {top: 24px; opacity: 0;}
`;

const ToastWrap = styled.div`
  position: fixed;
  width: calc(100% - 80px);
  max-width: calc(480px - 80px);
  top: 0;
  opacity: 0;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  background: rgba(32, 32, 32, 0.9);
  border-radius: 8px;
  z-index: 999;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 4px;
  font-size: 14px;
  line-height: 22px;
  transition: all 0.5s ease-in-out;
  -webkit-animation: ${toastAnimation} 2s;
  animation: ${toastAnimation} 2s;

  img {
    width: 24px;
    height: 24px;
    object-fit: cover;
  }
`;

const TryAgainToast = () => {
  const { t } = useTranslation();
  return (
    <ToastWrap>
      <img src="/img/alert.png" alt="alert" />
      {t('TRY_AGAIN')}
    </ToastWrap>
  );
};

export default TryAgainToast;
